'use strict';

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

exports["default"] = forwardRef;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function forwardRef(Component) {
  var ForwardRef = function (_React$Component) {
    (0, _inherits3["default"])(ForwardRef, _React$Component);

    function ForwardRef() {
      (0, _classCallCheck3["default"])(this, ForwardRef);
      return (0, _possibleConstructorReturn3["default"])(this, (ForwardRef.__proto__ || (0, _getPrototypeOf2["default"])(ForwardRef)).apply(this, arguments));
    }

    (0, _createClass3["default"])(ForwardRef, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            forwardRef = _props.forwardRef,
            rest = (0, _objectWithoutProperties3["default"])(_props, ['forwardRef']);
        return _react2["default"].createElement(Component, (0, _extends3["default"])({
          forwardRef: forwardRef
        }, rest));
      }
    }]);
    return ForwardRef;
  }(_react2["default"].Component);

  ForwardRef.propTypes = {
    forwardRef: _propTypes2["default"].object
  };

  var forwardRefFunc = function forwardRefFunc(props, ref) {
    return _react2["default"].createElement(ForwardRef, (0, _extends3["default"])({}, props, {
      forwardRef: ref
    }));
  };

  var name = Component.displayName || Component.name;
  forwardRef.displayName = 'ForwardRef(' + name + ')';
  return _react2["default"].forwardRef(forwardRefFunc);
}